export default {
	signUp: 'Zarejestruj się',
	password: 'Wyślemy Ci hasło na Twój adres e-mail',
	youHaveRegistered: 'Udało Ci się zarejestrować',
	checkEmail: email => `Proszę, sprawdź swój e-mail ${email}`,
	passportPhoto: 'Zdjęcie paszportowe  (ostatnia strona)',
	selfieWithPassport: 'Twoje zdjęcie z ostatnią stroną paszportu',
	legalDocumentPhoto: 'Zdjęcie legalnego wpisu do rejestru'
};
